/* jshint esversion: 6 */
/* jshint ignore:start */
import { useContext, useRef, useState } from "react";
import { getCountries, getCountryCallingCode } from "react-phone-number-input";
import "react-phone-number-input/style.css";
import { MyContext } from "../Context/MyProvider";
import { showToast } from "../showTost";
import axios from "axios";
import Eyeicon from "../assets/Icon/eye.svg";
import Eyeslashicon from "../assets/Icon/eye-slash.svg";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import secureLocalStorage from "react-secure-storage";

const Login = () => {
  const { t } = useTranslation();
  const { setIsLoginShow, setIsSignUpShow, ApiBaseUrl, setIsLogin } =
    useContext(MyContext);

  const [value, setValue] = useState("");
  const [password, setPassowrd] = useState("");
  const [email, setEmail] = useState("");
  const [passType, setPassType] = useState("Password");
  const [passType2, setPassType2] = useState("Password");
  const [passType3, setPassType3] = useState("Password");
  const [isPageShow, setIsPageShow] = useState("Login");
  const [otpBox, setOtpBox] = useState(Array(6).fill(""));
  const [sendOtp, setSendOtp] = useState("");
  const [newPassword, setNewPassword] = useState({ passowrd: "", confirm: "" });
  const [apiloading, setApiLoading] = useState(false);
  const [selecttype, setSelectType] = useState("Phone");
  const [showCcode, setShowCcode] = useState(false);
  const [searchCcode, setSearchCcode] = useState("");
  const [selectCcode, setSelectCcode] = useState("+91");

  const OtpRef = useRef(Array.from({ length: 6 }, () => null));

  const countries = getCountries();
  const FilterCCode = countries.filter((item) =>
    getCountryCallingCode(item).toString().includes(searchCcode),
  );

  const Navigate = useNavigate();

  const handleLogin = () => {
    if (apiloading) {
      return;
    }

    const Error = selecttype === "Phone" ? value : email;
    const toastTitle =
      selecttype === "Phone" ? "Please enter number" : "Please enter email";

    if (!Error) {
      showToast({ title: t(toastTitle), id: "warning" });
      return;
    }

    if (!password) {
      showToast({ title: t("Please enter password"), id: "warning" });
      return;
    }

    try {
      setApiLoading(true);

      const ulogin_data = selecttype === "Phone" ? value : email;

      const loginData = {
        ulogin_data,
        c_code: selectCcode,
        password: password,
      };

      axios
        .post(`${ApiBaseUrl}/customer/login`, loginData)
        .then((response) => {
          const { ResponseCode, message, customer_detail, socket_token } =
            response.data;
          if (ResponseCode === 200) {
            showToast({ title: message, id: "success" });
            Navigate("/");
            secureLocalStorage.setItem(
              "Loginuser",
              JSON.stringify(customer_detail),
            );
            secureLocalStorage.setItem("Userid", customer_detail.id);
            if (socket_token) {
              secureLocalStorage.setItem("socket_token", socket_token);
            }
            setIsLogin("123");
            setIsLoginShow(false);
          } else {
            showToast({ title: message, id: "error" });
          }
          setApiLoading(false);
        })
        .catch((err) => {
          console.error("Login Error:", err);
        });
    } catch (error) {
      console.error("Phone number formatting error:", error);
    }
  };

  const HandleChange = (index, value) => {
    const OTP = [...otpBox];
    OTP[index] = value;
    setOtpBox(OTP);
    if (value && !isNaN(value) && index < OtpRef.current.length - 1) {
      OtpRef.current[index + 1].focus();
    }
  };

  const HandleKeyPress = (index, e) => {
    if (e.key === "Backspace" && index > 0 && !e.target.value) {
      OtpRef.current[index - 1].focus();
    }
  };

  const HandleContinue = () => {
    if (apiloading) {
      return;
    }

    if (!value) {
      showToast({ title: t("Please enter number"), id: "warning" });
      return;
    }

    const Data = {
      phone: value,
      ccode: selectCcode,
    };

    setApiLoading(true);

    axios
      .post(`${ApiBaseUrl}/customer/mobile_check`, Data)
      .then((res) => {
        // console.log("mobile_check", res);
        const { ResponseCode, message, Result } = res.data;
        if (ResponseCode === 200 && !Result) {
          axios
            .get(`${ApiBaseUrl}/customer/otp_detail`)
            .then((res) => {
              // console.log("otp_detail", res);
              const { message } = res.data;
              if (message === "MSG91") {
                handleMSG91(Data);
              } else if (message === "Twilio") {
                handleTwilio(Data);
              } else {
                setIsPageShow("NewPass");
              }
            })
            .catch((error) => {
              console.error("otp_detail", error);
            });
        } else {
          showToast({ title: message, id: "error" });
          setApiLoading(false);
        }
      })
      .catch((error) => {
        console.error("mobile_check", error);
      });
  };

  const handleMSG91 = (data) => {
    axios.post(`${ApiBaseUrl}/customer/msg91`, data).then((res) => {
      // console.log("msg91", res);
      const { ResponseCode, message, otp } = res.data;
      if (ResponseCode === 200) {
        setApiLoading(false);
        showToast({ title: message, id: "success" });
        setIsPageShow("OTP");
        setSendOtp(otp);
      }
    });
  };

  const handleTwilio = (data) => {
    axios.post(`${ApiBaseUrl}customer/twilio`, data).then((res) => {
      // console.log("twilio", res);
      const { ResponseCode, message, otp } = res.data;
      if (ResponseCode === 200) {
        setApiLoading(false);
        showToast({ title: message, id: "success" });
        setIsPageShow("OTP");
        setSendOtp(otp);
      }
    });
  };

  const HandleVerifyOTP = () => {
    if (sendOtp === otpBox.join("")) {
      setIsPageShow("NewPass");
    } else {
      showToast({ title: t("OTP is invalid !!"), id: "error" });
    }
  };

  const HandleResetPass = () => {
    if (apiloading) {
      return;
    }

    if (!newPassword.passowrd && !newPassword.confirm) {
      showToast({ title: t("Enter Password !!"), id: "error" });
      return;
    }

    if (newPassword.passowrd === newPassword.confirm) {
      const Data = {
        phone: value,
        ccode: selectCcode,
        password: newPassword.confirm,
      };

      setApiLoading(true);

      axios
        .post(`${ApiBaseUrl}/customer/forgot_password`, Data)
        .then((res) => {
          // console.log("forgot_password", res);
          setApiLoading(false);
          const Id = res.data.ResponseCode === 200 ? "success" : "error";
          showToast({ title: res.data.message, id: Id });
          setIsLoginShow(false);
        })
        .catch((error) => {
          console.error("forgot_password", error);
        });
    } else {
      showToast({ title: t("Not Match Password !!"), id: "error" });
    }
  };

  const handleSelectCuntryCode = async (item) => {
    setSelectCcode(`+${getCountryCallingCode(item)}`);
    setShowCcode(false);
  };

  return (
    <div>
      {isPageShow === "Login" && (
        <div className="py-[10px] px-[20px] login-box">
          <h1 className="text-[22px] font-bold">{t("Sign in to Doctor")}</h1>
          <span className="text-gray-500 text-[16px] font-[500]">
            {t("welcome back Please enter your details.")}
          </span>

          <div className="border-[1px] inline-block rounded-[50px] p-[5px] mt-[5px]">
            <div className="flex items-center gap-[5px]">
              <button
                onClick={() => setSelectType("Phone")}
                className={`w-[100px] duration-[0.5s] ${selecttype === "Phone" && "bg-[#4038FF] text-white"} py-[4px] rounded-[50px] font-[500] text-[15px]`}
              >
                {t("Phone")}
              </button>
              <button
                onClick={() => setSelectType("Email")}
                className={`w-[100px] duration-[0.5s] ${selecttype === "Email" && "bg-[#4038FF] text-white"} py-[4px] rounded-[50px] font-[500] text-[15px]`}
              >
                {t("Email")}
              </button>
            </div>
          </div>

          {selecttype === "Phone" ? (
            <div className="relative gap-[5px] login-input focus-within:border-[#4038FF] mt-[10px] focus-within:border-[1px]">
              <svg
                width="30"
                height="30"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M16.5521 21.752C16.0931 21.752 15.6311 21.69 15.1751 21.565C9.01011 19.873 4.12909 14.995 2.43609 8.83402C2.05109 7.43302 2.26204 5.97301 3.03204 4.72501C3.80504 3.47101 5.0761 2.58601 6.5191 2.29801C7.4791 2.10601 8.4281 2.53401 8.9151 3.35501L10.4781 5.995C11.2371 7.277 10.86 8.928 9.61896 9.754L8.4881 10.506C9.5451 12.676 11.3229 14.459 13.4839 15.515L14.2462 14.378C15.0772 13.139 16.7281 12.768 18.0091 13.531L20.6522 15.107C21.4702 15.595 21.8931 16.55 21.7071 17.482C21.4191 18.925 20.5341 20.196 19.2811 20.969C18.4391 21.487 17.5021 21.752 16.5521 21.752ZM6.97809 3.75C6.92909 3.75 6.87911 3.75502 6.83111 3.76502C5.77711 3.97602 4.86412 4.611 4.31012 5.512C3.76112 6.402 3.61009 7.44101 3.88409 8.43601C5.43709 14.089 9.91608 18.566 15.5721 20.118C16.5681 20.391 17.604 20.239 18.493 19.691C19.393 19.136 20.0291 18.222 20.2361 17.186C20.2981 16.875 20.1571 16.556 19.8831 16.393L17.241 14.817C16.646 14.463 15.878 14.636 15.492 15.211L14.377 16.876C14.177 17.174 13.7911 17.288 13.4651 17.15C10.5021 15.911 8.09113 13.495 6.85113 10.521C6.71313 10.189 6.82899 9.807 7.12799 9.608L8.78912 8.50299C9.36512 8.11999 9.54007 7.353 9.18707 6.758L7.62408 4.11899C7.48708 3.88699 7.23909 3.75 6.97809 3.75Z"
                  fill="#25314C"
                />
              </svg>

              <div className="flex items-center gap-4">
                <div
                  onClick={() => setShowCcode(!showCcode)}
                  className="flex items-center border"
                >
                  <svg
                    width="20"
                    height="20"
                    className="cursor-pointer"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http:www.w3.org/2000/svg"
                  >
                    <path
                      d="M12 14.75C11.808 14.75 11.616 14.6771 11.47 14.5301L7.46999 10.5301C7.17699 10.2371 7.17699 9.76202 7.46999 9.46902C7.76299 9.17602 8.23803 9.17602 8.53103 9.46902L12.001 12.939L15.471 9.46902C15.764 9.17602 16.239 9.17602 16.532 9.46902C16.825 9.76202 16.825 10.2371 16.532 10.5301L12.532 14.5301C12.384 14.6771 12.192 14.75 12 14.75Z"
                      fill="#25314C"
                    />
                  </svg>
                  <h1 className="me-1">{selectCcode}</h1>
                </div>
              </div>
              <input
                type="tel"
                value={value}
                onChange={(e) => setValue(e.target.value)}
                className="w-[100%] bg-transparent outline-none px-[10px]"
                placeholder={t("Enter your number")}
              />
              {showCcode && (
                <div className="absolute z-[666]">
                  <div className="w-[100px] bg-white border border-gray-400">
                    <input
                      type="number"
                      value={searchCcode}
                      onChange={(e) => setSearchCcode(e.target.value)}
                      className="w-full px-[10px] py-[2px] outline-none border-b"
                      placeholder={t("Search")}
                    />
                    <ul className="max-h-[200px] scroll-container">
                      {FilterCCode.map((item, index) => {
                        return (
                          <li
                            key={index}
                            onClick={() => handleSelectCuntryCode(item)}
                            className="px-[10px] py-[2px] cursor-pointer hover:bg-gray-200"
                          >
                            +{getCountryCallingCode(item)}
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                </div>
              )}
            </div>
          ) : (
            <div className="login-input focus-within:border-[#4038FF] mt-[10px] focus-within:border-[1px]">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M18 20.75H6C3.582 20.75 2.25 19.418 2.25 17V8C2.25 5.582 3.582 4.25 6 4.25H18C20.418 4.25 21.75 5.582 21.75 8V17C21.75 19.418 20.418 20.75 18 20.75ZM6 5.75C4.423 5.75 3.75 6.423 3.75 8V17C3.75 18.577 4.423 19.25 6 19.25H18C19.577 19.25 20.25 18.577 20.25 17V8C20.25 6.423 19.577 5.75 18 5.75H6ZM13.0291 13.179L17.9409 9.60699C18.2759 9.36399 18.35 8.89401 18.106 8.55901C17.863 8.22501 17.3951 8.149 17.0581 8.394L12.146 11.966C12.058 12.03 11.941 12.03 11.853 11.966L6.94092 8.394C6.60292 8.149 6.13607 8.22601 5.89307 8.55901C5.64907 8.89401 5.72311 9.36299 6.05811 9.60699L10.97 13.18C11.278 13.404 11.639 13.515 11.999 13.515C12.359 13.515 12.7221 13.403 13.0291 13.179Z"
                  fill="#25314C"
                />
              </svg>

              <input
                onChange={(e) => setEmail(e.target.value)}
                type="text"
                placeholder={t("Enter email address")}
                className="w-[100%] bg-transparent outline-none px-[10px]"
              />
            </div>
          )}

          <div className="login-input focus-within:border-[#4038FF] mt-[20px] focus-within:border-[1px]">
            <svg
              width="26"
              height="26"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16 8.25H8.75V7C8.75 6.139 9.08905 5.3201 9.69604 4.7041C10.32 4.0891 11.138 3.75 12 3.75C13.485 3.75 14.778 4.75106 15.144 6.18506C15.246 6.58606 15.6599 6.82705 16.0549 6.72705C16.4569 6.62405 16.6999 6.21594 16.5969 5.81494C16.0629 3.71594 14.172 2.25 12 2.25C10.742 2.25 9.55099 2.74204 8.63599 3.64404C7.74199 4.55004 7.25 5.742 7.25 7V8.30396C5.312 8.56096 4.25 9.846 4.25 12V18C4.25 20.418 5.582 21.75 8 21.75H16C18.418 21.75 19.75 20.418 19.75 18V12C19.75 9.582 18.418 8.25 16 8.25ZM18.25 18C18.25 19.577 17.577 20.25 16 20.25H8C6.423 20.25 5.75 19.577 5.75 18V12C5.75 10.423 6.423 9.75 8 9.75H16C17.577 9.75 18.25 10.423 18.25 12V18ZM13.27 14C13.27 14.412 13.058 14.7601 12.75 14.9871V17C12.75 17.414 12.414 17.75 12 17.75C11.586 17.75 11.25 17.414 11.25 17V14.9619C10.962 14.7329 10.7649 14.395 10.7649 14C10.7649 13.31 11.32 12.75 12.01 12.75H12.02C12.71 12.75 13.27 13.31 13.27 14Z"
                fill="#25314C"
              />
            </svg>

            <input
              onChange={(e) => setPassowrd(e.target.value)}
              className="bg-transparent px-[10px] w-[100%] outline-none"
              type={passType}
              placeholder={t("Enter your passowrd")}
            />
            <img
              onClick={() =>
                passType === "text"
                  ? setPassType("Password")
                  : setPassType("text")
              }
              src={passType === "text" ? Eyeicon : Eyeslashicon}
              alt="LockIcon "
              className="w-[20px] cursor-pointer"
            />
          </div>

          <button
            onClick={() => setIsPageShow("Forgot")}
            className="font-[500] mt-[10px] "
          >
            {t("Forgot passowrd?")} <span className="text-[#4038FF]">{t("Reset it")}</span>
          </button>
          <button
            onClick={handleLogin}
            className="bg-[#4038FF] w-[100%] py-[8px] text-white font-bold rounded-[10px] mt-[20px]"
          >
            {apiloading ? (
              <div className="loader mx-auto"></div>
            ) : (
              <span>{t("Sign In")}</span>
            )}
          </button>
          <h1 className="mt-[10px] text-center font-[500]">
            {t("Don't have and account?")}{" "}
            <button
              onClick={() => {
                setIsLoginShow(false);
                setIsSignUpShow(true);
              }}
              className="text-[#4038FF] cursor-pointer"
            >
              {t("Sign Up")}
            </button>{" "}
          </h1>
        </div>
      )}

      {isPageShow === "Forgot" && (
        <div className="py-[10px] px-[20px]">
          <h1 className="text-center text-[24px] font-[500]">{t("Can't Sign in?")}</h1>
          <p className="text-center text-gray-500 text-[18px] leading-[25px]">
            {t("Enter the mobile number associated with you account, and RideNow will send you OTP to your register mobile number")}
          </p>
          <div className="relative login-input focus-within:border-[#4038FF] mt-[20px] focus-within:border-[1px]">
            <svg
              width="30"
              height="30"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16.5521 21.752C16.0931 21.752 15.6311 21.69 15.1751 21.565C9.01011 19.873 4.12909 14.995 2.43609 8.83402C2.05109 7.43302 2.26204 5.97301 3.03204 4.72501C3.80504 3.47101 5.0761 2.58601 6.5191 2.29801C7.4791 2.10601 8.4281 2.53401 8.9151 3.35501L10.4781 5.995C11.2371 7.277 10.86 8.928 9.61896 9.754L8.4881 10.506C9.5451 12.676 11.3229 14.459 13.4839 15.515L14.2462 14.378C15.0772 13.139 16.7281 12.768 18.0091 13.531L20.6522 15.107C21.4702 15.595 21.8931 16.55 21.7071 17.482C21.4191 18.925 20.5341 20.196 19.2811 20.969C18.4391 21.487 17.5021 21.752 16.5521 21.752ZM6.97809 3.75C6.92909 3.75 6.87911 3.75502 6.83111 3.76502C5.77711 3.97602 4.86412 4.611 4.31012 5.512C3.76112 6.402 3.61009 7.44101 3.88409 8.43601C5.43709 14.089 9.91608 18.566 15.5721 20.118C16.5681 20.391 17.604 20.239 18.493 19.691C19.393 19.136 20.0291 18.222 20.2361 17.186C20.2981 16.875 20.1571 16.556 19.8831 16.393L17.241 14.817C16.646 14.463 15.878 14.636 15.492 15.211L14.377 16.876C14.177 17.174 13.7911 17.288 13.4651 17.15C10.5021 15.911 8.09113 13.495 6.85113 10.521C6.71313 10.189 6.82899 9.807 7.12799 9.608L8.78912 8.50299C9.36512 8.11999 9.54007 7.353 9.18707 6.758L7.62408 4.11899C7.48708 3.88699 7.23909 3.75 6.97809 3.75Z"
                fill="#25314C"
              />
            </svg>
            <div className="flex items-center gap-4">
              <div
                onClick={() => setShowCcode(!showCcode)}
                className="flex items-center border"
              >
                <svg
                  width="20"
                  height="20"
                  className="cursor-pointer"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http:www.w3.org/2000/svg"
                >
                  <path
                    d="M12 14.75C11.808 14.75 11.616 14.6771 11.47 14.5301L7.46999 10.5301C7.17699 10.2371 7.17699 9.76202 7.46999 9.46902C7.76299 9.17602 8.23803 9.17602 8.53103 9.46902L12.001 12.939L15.471 9.46902C15.764 9.17602 16.239 9.17602 16.532 9.46902C16.825 9.76202 16.825 10.2371 16.532 10.5301L12.532 14.5301C12.384 14.6771 12.192 14.75 12 14.75Z"
                    fill="#25314C"
                  />
                </svg>
                <h1 className="me-1">{selectCcode}</h1>
              </div>
            </div>
            <input
              type="tel"
              value={value}
              onChange={(e) => setValue(e.target.value)}
              className="w-[100%] bg-transparent outline-none px-[10px]"
              placeholder={t("Enter your number")}
            />
            {showCcode && (
              <div className="absolute z-[666]">
                <div className="w-[100px] bg-white border border-gray-400">
                  <input
                    type="number"
                    value={searchCcode}
                    onChange={(e) => setSearchCcode(e.target.value)}
                    className="w-full px-[10px] py-[2px] outline-none border-b"
                    placeholder={t("Search")}
                  />
                  <ul className="max-h-[200px] scroll-container">
                    {FilterCCode.map((item, index) => {
                      return (
                        <li
                          key={index}
                          onClick={() => handleSelectCuntryCode(item)}
                          className="px-[10px] py-[2px] cursor-pointer hover:bg-gray-200"
                        >
                          +{getCountryCallingCode(item)}
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </div>
            )}
          </div>

          <button
            onClick={HandleContinue}
            className="w-[100%] bg-[#4038FF] font-[500] py-[8px] mt-[25px] text-white rounded-[10px]"
          >
            {apiloading ? (
              <div className="loader mx-auto"></div>
            ) : (
              <span>{t("Continue")}</span>
            )}
          </button>
          <button
            onClick={() => setIsPageShow("Login")}
            className="w-[100%] border-[1px] border-[#4038FF] font-[500] py-[8px] mt-[10px] text-[#4038FF] rounded-[10px]"
          >
            {t("Return to Sign In")}
          </button>
        </div>
      )}

      {isPageShow === "OTP" && (
        <div className="py-[10px] px-[20px] signup-box">
          <h1 className="font-[500] text-[20px]">{t("Awesome")}</h1>
          <p>{t("We have send the OTP to")} {value}</p>
          <h1>{t("Your OTP")} :- {sendOtp}</h1>
          <div className="flex items-center gap-[20px] mt-[10px]">
            {otpBox.map((value, index) => {
              return (
                <input
                  ref={(e) => (OtpRef.current[index] = e)}
                  key={index}
                  value={value}
                  className="otp-box focus-within:outline-[#4038FF]"
                  type="text"
                  maxLength="1"
                  onKeyDown={(e) => HandleKeyPress(index, e)}
                  onChange={(e) => HandleChange(index, e.target.value)}
                  inputMode="numeric"
                />
              );
            })}
          </div>
          <button
            onClick={HandleVerifyOTP}
            className="w-[100%] bg-[#4038FF] font-[500] py-[8px] mt-[25px] text-white rounded-[10px]"
          >
            {t("VERIFY OTP")}
          </button>
        </div>
      )}

      {isPageShow === "NewPass" && (
        <div className="py-[10px] px-[20px]">
          <h1 className="font-[500] text-[18px] text-center">
            {t("Create A New Password")}
          </h1>
          <div className="login-input focus-within:border-[#4038FF] mt-[20px] focus-within:border-[1px]">
            <svg
              width="26"
              height="26"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16 8.25H8.75V7C8.75 6.139 9.08905 5.3201 9.69604 4.7041C10.32 4.0891 11.138 3.75 12 3.75C13.485 3.75 14.778 4.75106 15.144 6.18506C15.246 6.58606 15.6599 6.82705 16.0549 6.72705C16.4569 6.62405 16.6999 6.21594 16.5969 5.81494C16.0629 3.71594 14.172 2.25 12 2.25C10.742 2.25 9.55099 2.74204 8.63599 3.64404C7.74199 4.55004 7.25 5.742 7.25 7V8.30396C5.312 8.56096 4.25 9.846 4.25 12V18C4.25 20.418 5.582 21.75 8 21.75H16C18.418 21.75 19.75 20.418 19.75 18V12C19.75 9.582 18.418 8.25 16 8.25ZM18.25 18C18.25 19.577 17.577 20.25 16 20.25H8C6.423 20.25 5.75 19.577 5.75 18V12C5.75 10.423 6.423 9.75 8 9.75H16C17.577 9.75 18.25 10.423 18.25 12V18ZM13.27 14C13.27 14.412 13.058 14.7601 12.75 14.9871V17C12.75 17.414 12.414 17.75 12 17.75C11.586 17.75 11.25 17.414 11.25 17V14.9619C10.962 14.7329 10.7649 14.395 10.7649 14C10.7649 13.31 11.32 12.75 12.01 12.75H12.02C12.71 12.75 13.27 13.31 13.27 14Z"
                fill="#25314C"
              />
            </svg>
            <input
              onChange={(e) =>
                setNewPassword({ ...newPassword, passowrd: e.target.value })
              }
              type={passType2}
              placeholder={t("Enter your password")}
              className="w-[100%] bg-transparent outline-none px-[10px]"
            />
            <img
              onClick={() =>
                passType2 === "text"
                  ? setPassType2("Password")
                  : setPassType2("text")
              }
              src={passType2 === "text" ? Eyeicon : Eyeslashicon}
              alt="LockIcon "
              className="w-[20px] cursor-pointer"
            />
          </div>
          <div className="login-input focus-within:border-[#4038FF] mt-[20px] focus-within:border-[1px]">
            <svg
              width="26"
              height="26"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16 8.25H8.75V7C8.75 6.139 9.08905 5.3201 9.69604 4.7041C10.32 4.0891 11.138 3.75 12 3.75C13.485 3.75 14.778 4.75106 15.144 6.18506C15.246 6.58606 15.6599 6.82705 16.0549 6.72705C16.4569 6.62405 16.6999 6.21594 16.5969 5.81494C16.0629 3.71594 14.172 2.25 12 2.25C10.742 2.25 9.55099 2.74204 8.63599 3.64404C7.74199 4.55004 7.25 5.742 7.25 7V8.30396C5.312 8.56096 4.25 9.846 4.25 12V18C4.25 20.418 5.582 21.75 8 21.75H16C18.418 21.75 19.75 20.418 19.75 18V12C19.75 9.582 18.418 8.25 16 8.25ZM18.25 18C18.25 19.577 17.577 20.25 16 20.25H8C6.423 20.25 5.75 19.577 5.75 18V12C5.75 10.423 6.423 9.75 8 9.75H16C17.577 9.75 18.25 10.423 18.25 12V18ZM13.27 14C13.27 14.412 13.058 14.7601 12.75 14.9871V17C12.75 17.414 12.414 17.75 12 17.75C11.586 17.75 11.25 17.414 11.25 17V14.9619C10.962 14.7329 10.7649 14.395 10.7649 14C10.7649 13.31 11.32 12.75 12.01 12.75H12.02C12.71 12.75 13.27 13.31 13.27 14Z"
                fill="#25314C"
              />
            </svg>
            <input
              onChange={(e) =>
                setNewPassword({ ...newPassword, confirm: e.target.value })
              }
              type={passType3}
              placeholder={t("Enter your confrim password")}
              className="w-[100%] bg-transparent outline-none px-[10px]"
            />
            <img
              onClick={() =>
                passType3 === "text"
                  ? setPassType3("Password")
                  : setPassType3("text")
              }
              src={passType3 === "text" ? Eyeicon : Eyeslashicon}
              alt="LockIcon "
              className="w-[20px] cursor-pointer"
            />
          </div>

          <button
            onClick={HandleResetPass}
            className="w-[100%] bg-[#4038FF] font-[500] py-[8px] mt-[25px] text-white rounded-[10px]"
          >
            {apiloading ? (
              <div className="loader mx-auto"></div>
            ) : (
              <span>{t("Continue")}</span>
            )}
          </button>
        </div>
      )}

      {showCcode && (
        <div
          onClick={() => setShowCcode(false)}
          className="w-full h-[100vh] fixed inset-0 z-[555]"
        ></div>
      )}
    </div>
  );
};

export default Login;
/* jshint ignore:end */
